export default __webpack_public_path__ + "static/bg-emotor-d75e3f9de18692bc5d16eff7cea562bc.jpg";